import {
  GET_SUBSCRIBED_DATA_FEEDS_SUCCESS,
  GET_SUBSCRIBED_DATA_FEEDS_FAILURE,
  GET_UPDATED_DATA_FEEDS_SUCCESS,
  GET_UPDATED_DATA_FEEDS_FAILURE,
} from '../../../../../store/actionTypes';

/**
 * initial state data
 */
const initialState: any = {
  subscribedFeeds: [],
  error: false,
  loading: true,
};

/**
 * Reducer for managing the config state
 * @param state
 * @param action
 * @returns
 */
const subscribedDataFeedReducer = (state = initialState, action: any): any => {
  let payload: any;
  const data = action.data && action.data.data;
  switch (action.type) {
    case GET_SUBSCRIBED_DATA_FEEDS_SUCCESS:
      payload = Object.assign([], state.subscribedFeeds, data?.subscriptions);
      return { ...state, subscribedFeeds: payload, loading: false };
    case GET_UPDATED_DATA_FEEDS_SUCCESS:
      payload = Object.assign([], data?.subscriptions);
      return { ...state, subscribedFeeds: payload, loading: false };
    case GET_UPDATED_DATA_FEEDS_FAILURE:
      return { ...state, error: true, loading: false };
    case GET_SUBSCRIBED_DATA_FEEDS_FAILURE:
      return { ...state, error: true, loading: false };
    default:
      return {
        ...state,
      };
  }
};

export default subscribedDataFeedReducer;
